export default __webpack_public_path__ + "static/media/reporticon.37261444.svg";